import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
import MinimumFacturable from '@/models/MinimumFacturable';
const rootPath = 'minimumFacturables';

class MinimumFacturableService {
  
    public async getByEntrepriseBopModelDomainApplication(bopModelId:string,entrepriseId:string,domainApplicationid:string): Promise<any> {
        return await apiClient.get(`${rootPath}${buildQuery({bopModelId,entrepriseId,domainApplicationid})}`);
    }
    public async save(minimumFacturable:MinimumFacturable): Promise<any> {
        return await apiClient.put(`${rootPath}/${minimumFacturable.id}`,minimumFacturable);
    }
    
}

export default new MinimumFacturableService();